import React, { useState } from 'react';
import { Link2, UploadCloud, Zap } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Link2,
    title: 'Connect Your Accounts',
    description: 'Connect your accounting software like QuickBooks or Xero in seconds. We support 50+ integrations.',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: UploadCloud,
    title: 'Upload Statements',
    description: 'Drag and drop bank statements or connect your bank directly for real-time transaction feeds.',
    color: 'bg-violet-100 text-violet-600'
  }, {
    icon: Zap,
    title: 'Berry Does the Rest',
    description: 'Our AI automatically matches transactions and flags anomalies for your review. It gets smarter every time.',
    color: 'bg-amber-100 text-amber-600'
  }];
  return <section id="how-it-works" className="py-24 bg-gray-50" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center mb-16" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-197">
            How Berry Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-198">
            Three simple steps to automated reconciliation and financial peace
            of mind.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-199">
          {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-200">

              <div className={`w-20 h-20 rounded-2xl flex items-center justify-center mb-6 ${step.color} transition-transform group-hover:scale-110 duration-300`} data-id="element-201">

                <step.icon className="h-10 w-10" data-id="element-202" />
              </div>
              <div className="relative" data-id="element-203">
                <span className="absolute -top-12 -left-6 text-8xl font-bold text-gray-200 opacity-50 -z-10 select-none" data-id="element-204">
                  {index + 1}
                </span>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-205">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-206">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}